import styled from 'styled-components';

export default styled.div`
  width: 5.5rem;
  padding: 0 0.5rem;
  background: #3f3f3f;
  color: #fff;
  line-height: 2rem;
  font-family: Jost, sans-serif;
  font-size: 1.3rem;
  font-style: normal;
  whiste-space: nowrap;
  font-weight: 300;
  position: absolute;
  top: -2rem;
  right: 0;
`;